var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 13,
    viewBox: "0 0 40 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5333 4.49708L32.0833 0.749996C31.9284 0.660173 31.7441 0.588878 31.541 0.540224C31.3379 0.491571 31.12 0.466522 30.9 0.466522C30.68 0.466522 30.4621 0.491571 30.259 0.540224C30.0559 0.588878 29.8716 0.660173 29.7167 0.749996V0.749996C29.4062 0.929551 29.232 1.17244 29.232 1.42562C29.232 1.6788 29.4062 1.92169 29.7167 2.10125L35.65 5.54166H1.66667C1.22464 5.54166 0.800716 5.64263 0.488155 5.82235C0.175595 6.00207 0 6.24583 0 6.5H0C0 6.75416 0.175595 6.99792 0.488155 7.17764C0.800716 7.35736 1.22464 7.45833 1.66667 7.45833H35.75L29.7167 10.9179C29.5604 11.007 29.4365 11.113 29.3518 11.2298C29.2672 11.3466 29.2237 11.4718 29.2237 11.5983C29.2237 11.7248 29.2672 11.8501 29.3518 11.9669C29.4365 12.0837 29.5604 12.1897 29.7167 12.2787C29.8716 12.3686 30.0559 12.4399 30.259 12.4885C30.4621 12.5372 30.68 12.5622 30.9 12.5622C31.12 12.5622 31.3379 12.5372 31.541 12.4885C31.7441 12.4399 31.9284 12.3686 32.0833 12.2787L38.5333 8.56041C39.4697 8.02135 39.9956 7.29062 39.9956 6.52875C39.9956 5.76687 39.4697 5.03614 38.5333 4.49708V4.49708Z",
    fill: "#52DE97"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b75a0b0bc3db5cc12ed66023ad9e738b.svg";
export { ForwardRef as ReactComponent };